import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { MobileTemplateGrid } from '../components/TemplateGrid/MobileTemplateGrid';
import { Footer } from '../../../components/Footer';
import { useTemplateNavigation } from '../hooks/useTemplateNavigation';
import s from './MobileTemplateSelection.scss';
import { useSelectedCategory, useSelectedThemeColor } from '../../../store/appStore';

export function MobileTemplateSelection() {
  const { t } = useTranslation();
  const selectedCategory = useSelectedCategory();
  const selectedThemeColor = useSelectedThemeColor();
  const { handleNext } = useTemplateNavigation();

  if (!selectedCategory) {
    return;
  }

  return (
    <Box direction="vertical" height="100%" width="100%" gap={2} className={s.templateContainer}>
      <Box direction="vertical" height="100%" className={s.content}>
        <Box direction="vertical" gap={1} className={s.textContainer}>
          <Heading className={s.title} size="medium">
            {t('SELECT_SITE_THEME')}
          </Heading>

          <Text>{t('THEME_AND_COLOR_SCHEME_FOR_YOUR_SITE')}</Text>
        </Box>

        <MobileTemplateGrid />
      </Box>

      <Footer
        isDisabled={!selectedThemeColor}
        onClick={handleNext}
        nextButtonText={t('NEXT')}
        showSuffixIcon={false}
        className={s.templateFooter}
      />
    </Box>
  );
}
